export default __webpack_public_path__ + "static/media/categorie.2fe91cc5.svg";